import React from 'react';
import { 
  LayoutDashboard, Users, ShieldCheck, Truck, Infinity 
} from 'lucide-react';

const PillarCard = ({ icon, title, features, theme }) => (
  <div style={{ 
    backgroundColor: 'white', 
    padding: '40px 32px', 
    borderRadius: '16px', 
    boxShadow: '0 10px 30px -5px rgba(0,0,0,0.05)', 
    textAlign: 'left',
    height: '100%',
    border: '1px solid #e2e8f0',
    borderTop: `4px solid ${theme.primary}`,
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.2s ease',
  }}>
    <div style={{ marginBottom: '25px', display: 'inline-block', padding: '12px', background: '#eff6ff', borderRadius: '12px', width: 'fit-content' }}>
      {icon}
    </div>
    
    <h3 style={{ marginBottom: '20px', color: theme.secondary, fontSize: '1.25rem', fontWeight: 'bold' }}>{title}</h3>
    
    <ul style={{ paddingLeft: '0', listStyle: 'none', margin: 0, flex: 1 }}>
      {features.map((feat, i) => (
        <li key={i} style={{ marginBottom: '16px', color: '#64748b', fontSize: '1rem', display: 'flex', alignItems: 'start', gap: '12px', lineHeight: '1.5' }}>
          <span style={{ color: theme.success || '#10b981', fontWeight: 'bold', marginTop: '2px' }}>•</span>
          <span>{feat}</span>
        </li>
      ))}
    </ul>
  </div>
);

const Features = ({ theme }) => {
  const pillars = [
    {
      title: "1. Operational Control",
      icon: <LayoutDashboard size={28} color={theme.primary} />,
      features: [
        "Daily Site Logs: Configurable questions with automated Permit triggers.",
        "Permit to Work: Standalone requests with logic jumps & custom approval chains.",
        "Contractor Pre-Qual: Automated document collection & expiry tracking."
      ]
    },
    {
      title: "2. Workforce Compliance",
      icon: <Users size={28} color={theme.primary} />,
      features: [
        "Worker Registry: Unlimited database. Zero-account setup via QR.",
        "Digital Inductions: Sign-on-glass verification for all personnel.",
        "Competency Tracking: Qualification/Ticket monitoring with expiry alerts."
      ]
    },
    {
      title: "3. Safety Assurance",
      icon: <ShieldCheck size={28} color={theme.primary} />,
      features: [
        "Audit & Inspection: Fully customisable templates with scoring.",
        // UPDATED LINE BELOW
        "Public QR Reporting: Anonymous hazard reporting without logging in.", 
        "Closed-Loop CAPA: 'Rectify & Verify' workflows for corrective actions."
      ]
    },
    {
      title: "4. Asset Management",
      icon: <Truck size={28} color={theme.primary} />,
      features: [
        "Equipment Gatekeeper: Pre-qualification documents tracking.",
        // UPDATED LINE BELOW
        "Scan-for-Status: Public QR codes show 'Green' (Safe) or 'Red' (Do Not Use).",
        "Auto-Lockout: Automated status changes based on compliance data."
      ]
    },
    {
      title: '5. The "Unlimited" Promise',
      icon: <Infinity size={28} color={theme.primary} />,
      features: [
        "Unlimited Users: Invite your whole team, subs, and clients.",
        "Unlimited Projects: Manage as many jobs as you need.",
        "Unlimited Data: No storage caps on your safety records."
      ]
    }
  ];

  return (
    <section id="features" style={{ padding: '100px 20px', backgroundColor: '#f8fafc', textAlign: 'center' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h2 style={{ fontSize: '2.5rem', color: theme.secondary, marginBottom: '20px', fontWeight: '800' }}>Everything you need to run a site</h2>
        
        <p style={{ fontSize: '1.2rem', color: '#64748b', marginBottom: '80px', maxWidth: '700px', margin: '0 auto 80px', lineHeight: '1.6' }}>
          A unified platform replacing fragmented paper trails, spreadsheets, and clunky legacy software.
        </p>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', 
          gap: '30px',
          alignItems: 'stretch'
        }}>
          {pillars.map((p, idx) => (
            <PillarCard key={idx} {...p} theme={theme} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;